/** @format */

import {Box, Button} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Container = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  maxWidth: `calc(400px + 400px + ${theme.spacing(8)})`,
}));

export const ContentRow = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(8),
  flexWrap: 'wrap',
}));

export const InstructionBlock = styled(Box)(({theme}) => ({
  flex: 1,
  maxWidth: '400px',
  minWidth: '280px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const InstructionText = styled(Box)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const EmergencyRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
}));

export const EmergencyIcon = styled(Box)(({theme}) => ({
  fontSize: '32px',
  color: theme.palette.semantic_dark?.primary.main,
  lineHeight: 1,
  flexShrink: 0,
}));

export const SafetyBlock = styled(Box)(({theme}) => ({
  flex: '1 0 0',
  maxWidth: '400px',
  minWidth: '280px',
  alignSelf: 'flex-start',
  backgroundColor: theme.palette.semantic_dark?.good.container,
  borderRadius: '16px',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
}));

export const SafetyTextColumn = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 0',
  gap: theme.spacing(2),
}));

export const SafetyTitle = styled(Box)(({theme}) => ({
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
  color: theme.palette.semantic_dark?.good.main,
}));

export const SafetyText = styled(Box)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.good.onContainer,
}));

export const SafetyIconWrapper = styled(Box)(({theme}) => ({
  '&.material-symbols-outlined': {
    fontSize: '72px',
  },
  color: theme.palette.semantic_dark?.good.main,
  lineHeight: 1,
  flexShrink: 0,
}));

export const ConnectButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.semantic_dark?.primary.main,
  color: theme.palette.semantic_dark?.primary.on,
  borderRadius: '8px',
  padding: theme.spacing(3.5, 4),
  gap: theme.spacing(2),
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '20px',
  textTransform: 'none',
  alignSelf: 'flex-start',
  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.primary.hover,
  },
}));

export const ButtonIcon = styled(Box)({
  fontSize: '20px',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
});

export const YandexHintBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(6),
}));

// YandexHintText is identical to InstructionText — reuse it
export const YandexHintText = InstructionText;
